import * as zod from 'zod';

import { PayloadState } from '@sb/routine-runner/types/PayloadState';

export const EnableGripperArguments = zod.object({
  deviceID: zod.string().optional(),
  payload: PayloadState.nullable().default(null),
  waitForGripperToInitialize: zod.boolean().default(false),
});

export type EnableGripperArguments = zod.infer<typeof EnableGripperArguments>;
